module.exports = __webpack_public_path__ + "static/media/specialised.fd9dc83e.svg";